import React from 'react';

import SwirlInteraction from 'ui/SwirlInteraction';

import 'css/ui/screens/HomeScreen.css';




class HomeScreen extends React.Component {

	render() {
		return (
			<div className="home-screen">
				<SwirlInteraction />
				<h1 className="fade-slide-up">
					Caleb Miller
				</h1>
				<p className="fade-slide-up anim-delay-1">
					is a creative web developer<br />working hard to make<br />things easy!
				</p>
			</div>
		);
	}
}

export default HomeScreen;



// WEBPACK FOOTER //
// ./src/ui/screens/HomeScreen.jsx